/* unplugin-vue-components disabled */import script from "./tabnavigation.vue?vue&type=script&lang=js"
export * from "./tabnavigation.vue?vue&type=script&lang=js"

import "./tabnavigation.vue?vue&type=style&index=0&id=89b8a002&lang=scss"

const __exports__ = script;

export default __exports__